// extracted by mini-css-extract-plugin
export var hidden = "_us-0";